import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GonvarriOrderDetailActionsComponent } from '../../components/gonvarri-order-detail-actions/gonvarri-order-detail-actions.component';
import {RouterLink} from "@angular/router";
import {AuthGuard, I18nModule, provideConfig, UrlModule} from "@spartacus/core";

@NgModule({
  declarations: [
    GonvarriOrderDetailActionsComponent
  ],
  imports: [
    CommonModule,
    RouterLink,
    UrlModule,
    I18nModule
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        AccountOrderDetailsActionsComponent: {
          component: GonvarriOrderDetailActionsComponent,
          guards: [AuthGuard],
        },
      }
    })
  ]
})
export class GonvarriOrderDetailActionsModule { }
